import { HeatmapPage } from "@/pages/dashboard/heatMap/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/dashboard/heatMap")({
    component: HeatmapPage,
});
